import { Stack, Text } from "@fluentui/react";
import { UserHeaderControl } from "components/auth/login";

import HeaderLink from "./components/HeaderLink";
import { innerHeaderStyle, productNameStyle, rightAligned } from "./styles";
import { URLS, EXPLORER_ENABLED } from "utils/constants";
import MSLogo from "./assets/ms-logo";

export const HeaderBar: React.FC = () => {
  return (
    <Stack
      className={innerHeaderStyle}
      horizontal
      wrap
      verticalAlign="center"
      tokens={headerTokens}
    >
      <MSLogo />
      <span style={{ fontSize: 26 }}>|</span>
      <HeaderLink to="/">
        <Text block variant="large" className={productNameStyle}>
          Planetary Computer Pro
        </Text>
      </HeaderLink>
      <HeaderLink isNav to={`${URLS.collections}`}>
        Collections
      </HeaderLink>
      {EXPLORER_ENABLED && (
        <HeaderLink isNav to={`${URLS.explorer}`}>
          Explorer
        </HeaderLink>
      )}
      <HeaderLink isNav to={`${URLS.operations}`}>
        Operations
      </HeaderLink>
      <HeaderLink isNav to={`${URLS.settings}`}>
        Settings
      </HeaderLink>
      <HeaderLink isNav to={`${URLS.docs}`} target="_blank">
        Documentation
      </HeaderLink>
      <div className={rightAligned}>
        <Stack horizontal verticalAlign="center" tokens={authSectionTokens}>
          <UserHeaderControl />
        </Stack>
      </div>
    </Stack>
  );
};

const headerTokens = { childrenGap: "10px 21px" };
const authSectionTokens = { childrenGap: 4 };
